import { render, staticRenderFns } from "./CookiePolicyAnnoucement.vue?vue&type=template&id=44d26df1&"
import script from "./CookiePolicyAnnoucement.vue?vue&type=script&lang=js&"
export * from "./CookiePolicyAnnoucement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d26df1')) {
      api.createRecord('44d26df1', component.options)
    } else {
      api.reload('44d26df1', component.options)
    }
    module.hot.accept("./CookiePolicyAnnoucement.vue?vue&type=template&id=44d26df1&", function () {
      api.rerender('44d26df1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CookiePolicyAnnoucement.vue"
export default component.exports